import { render } from "./wUploadMedia.vue?vue&type=template&id=20de020c&ts=true"
import script from "./wUploadMedia.vue?vue&type=script&lang=ts"
export * from "./wUploadMedia.vue?vue&type=script&lang=ts"

import "./wUploadMedia.vue?vue&type=style&index=0&id=20de020c&lang=css"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__